import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { NavigationItem } from '@ot/shared/model';

@Injectable({
  providedIn: 'root'
})
export class NavigationLinkService {
  // TODO: Move this REGEX to a common utils
  private static readonly absoluteURLRegex = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;

  constructor(private router: Router) {}

  isLink(element: HTMLElement): boolean {
    return (
      element.classList.contains('is-link') && element.hasAttribute('href')
    );
  }

  isInternalLink(element: HTMLElement): boolean {
    const url = element.getAttribute('href');
    return (
      !url.match('.*localhost.*') &&
      !url.match(NavigationLinkService.absoluteURLRegex)
    );
  }

  mapActiveLinks(links: NavigationItem[]): NavigationItem[] {
    return links.map(this.mapActiveLink.bind(this));
  }

  private mapActiveLink(link: NavigationItem): NavigationItem {
    const mappedLink = {
      ...link,
      active: this.router.isActive(link.url, !!link.exactMatch)
    };

    if (Array.isArray(mappedLink.children) && mappedLink.children.length) {
      mappedLink.children = mappedLink.children.map(
        this.mapActiveLink.bind(this)
      );
    }

    return mappedLink;
  }
}
